import styles from "./Contato.module.css";
import foto from "../../Imgs/Entre.png";
function Contato() {
  return (
    <div className={styles.container}>
      <h3 id="contato">//Contato</h3>

      <div className={styles.conteudo}>
        <div>
          <h4>Entre em contato com a gente</h4>
          <p>
            {" "}
            <span>Email:</span> geografiaemjogos@gmail.com
          </p>
          <p>
            {" "}
            <span>Instagram:</span>{" "}
            <a href="https://www.instagram.com/geografiaemjogosufpel/">
              @geografiaemjogosufpel
            </a>
          </p>
        </div>
        <img src={foto} alt="contato"></img>
      </div>

      <div align="center" className={styles.contador}>
        <p>Total de visitas:</p>
        <a href="https://contador.s12.com.br">
          <img
            src="https://contador.s12.com.br/img-7734bY11W22D899W-19.gif"
            border="0"
            alt="estatisticas gratis"
          />
        </a>
        
        <script
          type="text/javascript"
          src="https://contador.s12.com.br/ad.js?id=7734bY11W22D899W"
        ></script>
      </div>
    </div>
  );
}
export default Contato;
